import {Box, Grid, padding, Stack} from "@mui/system";
import React, {useCallback, useMemo, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Link, useNavigate, useParams} from "react-router-dom";
import style from "../../assets/css/client-details.module.scss";
import {
  Breadcrumbs,
  Button,
  Divider,
  FormControl,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";

import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  IoCloseOutline,
  IoCopyOutline,
  IoDownloadOutline,
} from "react-icons/io5";
import {PiDownloadSimple} from "react-icons/pi";
import GlobalModal from "../global-fields/GlobalModal";
import {selectUiState, setUiData} from "../../store/uiSlice";
import {BsCheckSquare, BsExclamationSquare} from "react-icons/bs";
import ClaimFormModal from "../claim-form-modal/ClaimFormModal";
import GlobalSelectField from "../global-fields/GlobalSelectField";
import {useEffect} from "react";
import {GET_DETAILS} from "../../constants/apiConstant";
import {removeCookies, toCapitalCase} from "../../constants/helper";
import {selectDataStoreState, setDataStore} from "../../store/dataSlice";
import GlobalNotificationPopup from "../global-fields/GlobalNotificationPopup";
import NoDataComponent from "../no-data";
import {saveAs} from "file-saver";
import {HiOutlineClock} from "react-icons/hi2";
import Drawer from "@mui/material/Drawer";
import Profile from "../dashboard/profile";

const shippingKeyNamesObj = {
  // --- Section 2 ---
  airfreight_under_section2: "Airfreight",
  armed_car_service_under_section2: "Armed Car Service",
  fed_exp_ups_under_section2: "Secure Overnight",
  registered_mail_under_section2: "Registered Mail",
  secure_overnight_under_section2: "Fed Exp Ups",
  usps_express_mail_under_section2: "USPS Express Mail",
  // airfreight_under_section2: "Airfreight section 2",
  // armed_car_service_under_section2: "Armed car service section 2",
  // fed_exp_ups_under_section2: "Secure overnight section 2",
  // registered_mail_under_section2: "Registered mail section 2",
  // secure_overnight_under_section2: "Fed exp ups section 2",
  // usps_express_mail_under_section2: "Usps express mail section 2",

  // --- Within USA/Canada ---
  airfreight_within_usa_canada: "Airfreight Within USA Canada",
  armed_car_within_usa_canada: "Armed Car Within USA Canada",
  fed_exp_ups_within_usa_canada: "Fed Exp Ups Within USA Canada",
  registered_mail_within_usa_canada: "Registered Mail Within USA Canada",
  secure_overnight_within_usa_canada: "Secure Overnight Within USA Canada",
  usps_express_mail_within_usa_canada: "USPS Express Mail Within USA Canada",

  // --- Elsewhere ---
  airfreight_elsewhere: "Airfreight Elsewhere",
  armed_car_elsewhere: "Armed Car Elsewhere",
  fed_exp_ups_elsewhere: "Fed Exp Ups Elsewhere",
  registered_mail_elsewhere: "Registered mail Elsewhere",
  secure_overnight_elsewhere: "Secure Overnight Elsewhere",
  usps_express_mail_elsewhere: "USPS Express Mail Elsewhere",
};

const DetailsComponent = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {type, uid} = useParams();
  const {detailsData} = useSelector(selectDataStoreState);
  const {showLoader, emiModal} = useSelector(selectUiState);

  const [open, setOpen] = React.useState(false);
  const [openEdit, setOpenEdit] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };
  const toggleEditDrawer = (newOpen) => () => {
    setOpenEdit(newOpen);
  };

  //const policyNumber = "XXXXXXXXX";
  const [tooltipOpen, setTooltipOpen] = useState(false);
  // const [currentPolicy, setCurrentPolicy] = useState(null);

  //const submittedPropList = submittedProposalsData || [];

  // console.log("detailsData", detailsData);

  const fetchDetails = useCallback(
    async (proposalID = null) => {
      if (!type || !uid) {
        return;
      }
      // return;
      dispatch(setUiData({showLoader: true}));

      let data = {};
      if (proposalID) {
        data = {...data, proposal_id: proposalID};
      } else if (type === "client") {
        data = {...data, user_id: uid};
      } else {
        data = {...data, proposal_id: uid};
      }

      const options = {
        method: GET_DETAILS.method,
        headers: GET_DETAILS.headers,
        body: JSON.stringify(data),
      };

      try {
        const response = await fetch(GET_DETAILS.url, options);
        const res = await response.json();
        if (res.status == 1) {
          // setCurrentPolicy(res?.data?.policy_details)
          // if (proposalID) {
          //   let newDetails = { ...detailsData }
          //   newDetails["payment_details"] = res.data?.payment_details;
          //   newDetails["policy_details"] = res.data?.policy_details;
          //   dispatch(
          //     setDataStore({
          //       detailsData: newDetails,
          //     })
          //   );
          // } else {
          //   dispatch(
          //     setDataStore({
          //       detailsData: res?.data || null,
          //     })
          //   );
          // }
          const data = res?.data || null;
          const updatedDetails = proposalID
            ? {
                ...detailsData,
                payment_details: data?.payment_details,
                policy_details: data?.policy_details,
              }
            : data;
          dispatch(
            setDataStore({
              detailsData: updatedDetails,
            })
          );
        } else {
          console.error("Error fetching proposals");
        }
      } catch (error) {
        removeCookies("isLogin");
        GlobalNotificationPopup({type: "error", message: error});
        navigate("/");
      } finally {
        dispatch(setUiData({showLoader: false}));
      }
    },
    [detailsData, type, uid]
  );

  useEffect(() => {
    // if (isFirstRender.current) {
    //   isFirstRender.current = false; // Prevent the second fetch caused by Strict Mode
    //   return;
    // }
    fetchDetails();
  }, []);
  //   const handleEndorsementBtn = (row) => {
  //     dispatch(setDataStore({ endorsementParentProposal: row }));
  //     navigate("/endorsements");
  //   };
  //   const handleExhibitionBtn = (row) => {
  //     dispatch(setDataStore({ exhibitionParentProposal: row }));
  //     navigate("/exhibition-coverage");
  //   };
  // const handleClickOpenClaimForm = (row) => {
  //     setCurrentRow(row);
  //     setClaimForm(true);
  //       dispatch(setDataStore({
  //       claimFormParentData: row
  //     }))
  //     dispatch(setUiData({
  //       claimFormModal: true
  //     }))
  //   };
  const currentPolicy = useMemo(
    () => detailsData?.policy_details,
    [detailsData]
  );

  const openEmiModal = () => {
    dispatch(
      setUiData({
        emiModal: true,
      })
    );
  };

  const handleCloseEmiModal = () => {
    dispatch(
      setUiData({
        emiModal: false,
      })
    );
  };

  const handleCopy = (data) => {
    navigator.clipboard
      .writeText(data)
      .then(() => {
        setTooltipOpen(true);
        setTimeout(() => setTooltipOpen(false), 1000);
      })
      .catch((err) => {
        console.error("Copy failed", err);
      });
  };

  const handleAction = (type, data) => {
    // console.log("Action Type:", type, "Data:", data);
    if (!data?.policy_number) {
      GlobalNotificationPopup({
        type: "error",
        message: "No Policy Issued",
      });
      return;
    }
    switch (type) {
      case "claim-history":
        dispatch(
          setDataStore({
            claimHistoryParentProposal: data,
            endorsementParentProposal: null,
            exhibitionParentProposal: null,
          })
        );
        navigate("/claim-history");
        break;

      case "endorsement":
        dispatch(
          setDataStore({
            claimHistoryParentProposal: null,
            endorsementParentProposal: data,
            exhibitionParentProposal: null,
          })
        );
        navigate("/endorsements");
        break;

      case "exhibition":
        dispatch(
          setDataStore({
            claimHistoryParentProposal: null,
            endorsementParentProposal: null,
            exhibitionParentProposal: data,
          })
        );
        navigate("/exhibition-coverage");
        break;

      default:
        console.warn("Unknown action type:", type);
        break;
    }
  };

  const handleDownload00 = (policy_file) => {
    // console.log(" PDF:", row?.policy_file);
    if (!policy_file) {
      console.error("Invalid PDF URL");
      return;
    }
    window.open(policy_file, "_blank");
  };

  const handleDownload = (policy_file) => {
    if (!policy_file) {
      alert("Invalid PDF URL");
      return;
    }

    saveAs(policy_file, policy_file.split("/").pop());
  };

  const handleClickOpenClaimForm = (data) => {
    dispatch(
      setDataStore({
        claimFormParentData: data,
      })
    );
    dispatch(
      setUiData({
        claimFormModal: true,
      })
    );
  };

  const fetchDetailsAgain = (proposalID) => {
    fetchDetails(proposalID);
  };
  const fetchDetailsAfterUpdate = () => {
    fetchDetails();
    toggleEditDrawer(false);
  };
  // console.log("detailsData?.user_details", detailsData);

  return (
    <>
      <Grid
        container
        spacing={3}
        className="customeContainer"
        justifyContent="center"
      >
        <Grid size={{xs: 12, lg: 12}} sx={{mt: 2}}>
          <div className={style.propPagination}>
            <Breadcrumbs aria-label="breadcrumb">
              <Link underline="hover" color="inherit" to="/dashboard">
                Dashboard
              </Link>
              <Link
                underline="hover"
                color="inherit"
                to={type === "client" ? "/clients" : "/issued-policy"}
              >
                {type === "client" ? "Clients" : "Issued Policies"}
              </Link>
              <Typography sx={{color: "text.primary"}}>Details</Typography>
            </Breadcrumbs>
          </div>
        </Grid>
      </Grid>
      {/* <Box sx={{ mt: 2 }}></Box> */}

      <Grid
        container
        spacing={3}
        className="customeContainer"
        justifyContent="center"
      >
        <Grid size={{xs: 12, lg: 12}} sx={{mt: 2}}>
          <div className={style.policyDetailsMain}>
            {/* {detailsData?.policy_details?.policy_number ? ( */}
            {type !== "client" ? (
              <div className={style.policyDetails}>
                <h2>
                  Policy No :{" "}
                  <span>{detailsData?.policy_details?.policy_number}</span>
                </h2>
                <div>
                  <Tooltip
                    arrow
                    title="Policy No. Copied!"
                    placement="top"
                    open={tooltipOpen}
                    onClose={() => setTooltipOpen(false)}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    slotProps={{
                      tooltip: {
                        sx: {
                          backgroundColor: "#90d790", // Light green background
                          color: "white", // White text
                          fontSize: "0.75rem",
                          padding: "6px 12px",
                          borderRadius: "6px",
                        },
                      },
                      arrow: {
                        sx: {
                          color: "#90d790", // Same as tooltip background
                        },
                      },
                    }}
                  >
                    <span
                      onClick={() =>
                        handleCopy(detailsData?.policy_details?.policy_number)
                      }
                      style={{cursor: "pointer"}}
                    >
                      <IoCopyOutline />
                    </span>
                  </Tooltip>

                  <span
                    onClick={() =>
                      handleDownload(detailsData?.policy_details?.policy_file)
                    }
                  >
                    <PiDownloadSimple />
                  </span>
                </div>
              </div>
            ) : (
              <div className={style.policyDetails}>
                <h2>
                  Client Name :{" "}
                  <span style={{color: "#474747", fontSize: "22px"}}>
                    {toCapitalCase(detailsData?.user_details?.full_name)}
                  </span>
                </h2>
              </div>
            )}
            {type === "client" && detailsData?.policy_list?.length ? (
              <div className={style.policySelect}>
                <GlobalSelectField
                  isPolicy={true}
                  value={currentPolicy?.proposal_id}
                  onChange={
                    (e) => fetchDetailsAgain(e.target.value)
                    // creditDebitCardFormik.setFieldValue(
                    //   "card_exp_month",
                    //   e.target.value
                    // )
                  }
                  // onBlur={creditDebitCardFormik.handleBlur}
                  // error={
                  //   creditDebitCardFormik.touched.card_exp_month &&
                  //   Boolean(creditDebitCardFormik.errors.card_exp_month)
                  // }
                  // helperText={
                  //   creditDebitCardFormik.touched.card_exp_month &&
                  //   creditDebitCardFormik.errors.card_exp_month
                  // }
                  // placeH="Select policy"
                  menuItems={detailsData?.policy_list}
                />
              </div>
            ) : null}
          </div>

          <Grid size={{xs: 12, lg: 12}} sx={{mt: 1, mb: 3}}>
            <Box className={style.clientDetailsMenu}>
              <Stack
                className={style.clientDetailsStack}
                direction="row"
                divider={
                  <Divider width="10px" orientation="vertical" flexItem />
                }
                spacing={2}
              >
                <Typography variant="body2" color="primary">
                  <span
                    onClick={() =>
                      handleAction("claim-history", detailsData?.policy_details)
                    }
                  >
                    Claim History
                  </span>
                </Typography>
                <Typography variant="body2" color="primary">
                  <span
                    onClick={() =>
                      handleAction("endorsement", detailsData?.policy_details)
                    }
                  >
                    Endorsements
                  </span>
                </Typography>
                <Typography variant="body2" color="primary">
                  <span
                    onClick={() =>
                      handleAction("exhibition", detailsData?.policy_details)
                    }
                  >
                    Exhibitions
                  </span>
                </Typography>
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </Grid>

      <section className={style.profileSection}>
        <Grid container spacing={2} className="customeContainer">
          <Grid size={{xs: 12, lg: 6}}>
            <Grid container spacing={2}>
              <Grid size={{xs: 12}}>
                <div className={style.myAccountDetails}>
                  <div className={style.myAccount}>
                    <h2>Client Details </h2>
                    {type === "client" ? (
                      <Box className={style.detailsClaimBtn}>
                        <Button
                          sx={{mr: 1}}
                          variant="contained"
                          color="primary"
                          onClick={toggleEditDrawer(true)}
                        >
                          Edit
                        </Button>
                      </Box>
                    ) : null}
                  </div>
                  <div className={style.clientDetailsText}>
                    {detailsData?.user_details ? (
                      <ul>
                        {detailsData?.user_details?.full_name ? (
                          <li>
                            <p>Client Name</p>
                            <p>
                              {toCapitalCase(
                                detailsData?.user_details?.full_name
                              )}
                            </p>
                          </li>
                        ) : null}
                        {detailsData?.user_details?.mobile_no ? (
                          <li>
                            <p>Contact Number</p>
                            <p>{detailsData?.user_details?.mobile_no}</p>
                          </li>
                        ) : null}
                        {detailsData?.user_details?.email ? (
                          <li>
                            <p>Email</p>
                            <p>{detailsData?.user_details?.email}</p>
                          </li>
                        ) : null}
                        {detailsData?.user_details?.company ? (
                          <li>
                            <p>Company</p>
                            <p>{detailsData?.user_details?.company}</p>
                          </li>
                        ) : null}
                        {detailsData?.user_details?.address1 ? (
                          <li>
                            <p>Company address Line 1</p>
                            <p>{detailsData?.user_details?.address1}</p>
                          </li>
                        ) : null}
                        {detailsData?.user_details?.address2 ? (
                          <li>
                            <p>Company address Line 2</p>
                            <p>{detailsData?.user_details?.address2}</p>
                          </li>
                        ) : null}
                        {detailsData?.user_details?.city ? (
                          <li>
                            <p>City</p>
                            <p>{detailsData?.user_details?.city}</p>
                          </li>
                        ) : null}
                        {detailsData?.user_details?.state ? (
                          <li>
                            <p>State</p>
                            <p>{detailsData?.user_details?.state}</p>
                          </li>
                        ) : null}
                        {detailsData?.user_details?.zipcode ? (
                          <li>
                            <p>Zip</p>
                            <p>{detailsData?.user_details?.zipcode}</p>
                          </li>
                        ) : null}
                        {detailsData?.user_details?.country ? (
                          <li>
                            <p>Country</p>
                            <p>{detailsData?.user_details?.country}</p>
                          </li>
                        ) : null}
                        {detailsData?.user_details?.assigned_agent ? (
                          <li>
                            <p>Assigned Agent</p>
                            <p>
                              {toCapitalCase(
                                detailsData?.user_details?.assigned_agent
                              )}{" "}
                            </p>
                          </li>
                        ) : null}
                        {detailsData?.user_details?.agent_email ? (
                          <li>
                            <p>Assigned Agent Email</p>
                            <p>{detailsData?.user_details?.agent_email}</p>
                          </li>
                        ) : null}
                      </ul>
                    ) : (
                      !showLoader && <NoDataComponent />
                    )}
                  </div>
                </div>
              </Grid>
            </Grid>
          </Grid>
          <Grid size={{xs: 12, lg: 6}}>
            <Grid container spacing={2}>
              <Grid size={{xs: 12, lg: 12}}>
                <div className={style.myAccountDetails}>
                  <div className={style.myAccount}>
                    <h2>Policy Details </h2>
                  </div>
                  <div className={style.clientDetailsText}>
                    {detailsData?.policy_details?.policy_number ? (
                      <ul>
                        {detailsData?.policy_details?.policy_number ? (
                          <li>
                            <p>Policy Number</p>
                            <p>{detailsData?.policy_details?.policy_number}</p>
                          </li>
                        ) : null}
                        {detailsData?.policy_details?.formated_hard_quote ? (
                          <li>
                            <p>Amount</p>
                            <p>
                              {detailsData?.policy_details?.formated_hard_quote}
                            </p>
                          </li>
                        ) : null}
                        {detailsData?.policy_details?.issued_date ? (
                          <li>
                            <p>Issued Date</p>
                            <p>{detailsData?.policy_details?.issued_date}</p>
                          </li>
                        ) : null}
                        {detailsData?.policy_details?.expiry_date ? (
                          <li>
                            <p>Expiry Date</p>
                            <p>{detailsData?.policy_details?.expiry_date}</p>
                          </li>
                        ) : null}

                        {/* <div className={style.policyDetailsAccordionMain}>
                      <Accordion sx={{ mt: 1 }}  className="proposal_accordion">
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1-content"
                          id="panel1-header"
                        >
                          <Typography component="span">Accordion 1</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
                          malesuada lacus ex, sit amet blandit leo lobortis eget.
                        </AccordionDetails>
                      </Accordion>
                    </div> */}

                        {detailsData?.policy_details?.policy_number ? (
                          <Box className={style.detailsClaimBtn}>
                            <Button
                              sx={{mr: 1}}
                              variant="contained"
                              color="primary"
                              onClick={toggleDrawer(true)}
                            >
                              More Details
                            </Button>
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={() =>
                                handleClickOpenClaimForm(
                                  detailsData?.policy_details
                                )
                              }
                            >
                              Request Claim
                            </Button>
                          </Box>
                        ) : null}
                      </ul>
                    ) : (
                      !showLoader && <NoDataComponent />
                    )}
                  </div>
                </div>
              </Grid>
              <Grid size={{xs: 12, lg: 12}}>
                <div className={style.myAccountDetails}>
                  <div className={style.myAccount}>
                    <h2>Payment Details </h2>
                  </div>
                  <div className={style.clientDetailsText}>
                    {detailsData?.payment_details?.formatted_amount ? (
                      <ul>
                        {detailsData?.payment_details?.formatted_amount ? (
                          <li>
                            <p>Amount</p>
                            <p>
                              {detailsData?.payment_details?.formatted_amount}
                            </p>
                          </li>
                        ) : null}
                        {detailsData?.payment_details?.ref_id &&
                        detailsData?.payment_details?.ref_id !== "" ? (
                          <li>
                            <p>Reference ID</p>
                            <p>{detailsData?.payment_details?.ref_id}</p>
                          </li>
                        ) : null}
                        {detailsData?.payment_details?.payment_date ? (
                          <li>
                            <p>Payment Date</p>
                            <p>{detailsData?.payment_details?.payment_date}</p>
                          </li>
                        ) : null}
                        {detailsData?.payment_details?.payment_type ? (
                          <li>
                            <p>Paid Through</p>
                            <p>
                              {detailsData?.payment_details?.payment_type ===
                              "EMI"
                                ? "Credit/Debit Card"
                                : "Cheque"}
                            </p>
                          </li>
                        ) : null}
                        {detailsData?.payment_details?.payment_type ===
                        "EMI" ? (
                          <li>
                            <p>EMI Frequency</p>
                            <p>
                              {detailsData?.payment_details?.emi_type
                                ?.toLowerCase()
                                .replace(/^\w/, (c) => c?.toUpperCase())}
                            </p>
                          </li>
                        ) : null}
                        {detailsData?.payment_details?.cheque_number ? (
                          <li>
                            <p>Cheque Number</p>
                            <p>{detailsData?.payment_details?.cheque_number}</p>
                          </li>
                        ) : null}
                        {detailsData?.payment_details?.emi_details?.length ? (
                          <li>
                            <p>EMIs</p>
                            <p>
                              <span onClick={openEmiModal}> View EMIs </span>
                            </p>
                          </li>
                        ) : null}
                      </ul>
                    ) : (
                      !showLoader && <NoDataComponent />
                    )}
                  </div>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </section>

      <GlobalModal
        open={emiModal}
        handleClose={handleCloseEmiModal}
        aria-labelledby="emi-details"
        closeIcon={true}
        title={"EMI Details"}
        // subtitle={`Total EMIs: 12 Months`}
        dialogTitleClass={style.claimPopTitle}
        // disableBackdropClick={true}
        dialogContent={
          <Grid container spacing={0}>
            <Grid size={{xs: 12, md: 12}} className={style.claimPopMain}>
              <Paper className={style.propTableMain}>
                <TableContainer component={Paper} className="emi-details-table">
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell align="center">#</TableCell>
                        <TableCell align="center">EMI Date</TableCell>
                        <TableCell align="center">EMI Amount</TableCell>
                        <TableCell align="center">Status</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {detailsData?.payment_details?.emi_details?.length
                        ? detailsData?.payment_details?.emi_details.map(
                            (row, rowIndex) => (
                              <TableRow
                                key={row.payment_date}
                                sx={{
                                  "&:last-child td, &:last-child th": {
                                    border: 0,
                                  },
                                }}
                              >
                                <TableCell align="center">
                                  {rowIndex + 1}
                                </TableCell>

                                <TableCell
                                  component="th"
                                  scope="row"
                                  align="center"
                                >
                                  {row.payment_date}
                                </TableCell>
                                <TableCell align="center">
                                  {row.formatted_amount}
                                </TableCell>
                                <TableCell align="center">
                                  {row.status == 0 ? (
                                    <HiOutlineClock color="#ff8607" size={28} />
                                  ) : row.status == 1 ? (
                                    <BsCheckSquare color="#00BA34" size={24} />
                                  ) : row.status == 2 ? (
                                    <BsExclamationSquare
                                      color="#FF2116"
                                      size={24}
                                    />
                                  ) : (
                                    <span
                                      style={{
                                        color: "#FF2116",
                                      }}
                                    >
                                      N/A
                                    </span>
                                  )}
                                </TableCell>
                              </TableRow>
                            )
                          )
                        : null}
                    </TableBody>
                  </Table>
                  {detailsData?.payment_details?.emi_details?.length > 0
                    ? null
                    : !showLoader && <NoDataComponent />}
                </TableContainer>
              </Paper>
            </Grid>
          </Grid>
        }
      ></GlobalModal>
      <ClaimFormModal />

      <Drawer anchor="right" open={open} onClose={toggleDrawer(false)}>
        <Box
          sx={{width: {xl: 1024, lg: 800, md: 800, sm: 650, xs: 350}}}
          role="presentation"
          className={style.DetailsDrawerMain}
        >
          <div>
            <IoCloseOutline
              onClick={toggleDrawer(false)}
              className={style.DetailsDrawerClose}
            />
          </div>

          <Grid container spacing={2} sx={{pl: 2, pr: 2}}>
            <Grid size={{xs: 12, md: 12}}>
              <div className={style.PolicyDetailsDrawerTitle}>
                <h2>
                  Policy No :{" "}
                  <span>{detailsData?.policy_details?.policy_number}</span>
                </h2>
              </div>

              {detailsData?.policy_details?.policy_number ? (
                <Box sx={{mb: 2}}>
                  <div className={style.myAccountDetails}>
                    <div className={style.myAccount}>
                      <h2>Basic Details </h2>
                    </div>
                    <div className={style.clientDetailsText}>
                      <ul>
                        {detailsData?.policy_details?.policy_number ? (
                          <li>
                            <p>Policy Number</p>
                            <p>{detailsData?.policy_details?.policy_number}</p>
                          </li>
                        ) : null}
                        {detailsData?.policy_details?.formated_hard_quote ? (
                          <li>
                            <p>Amount</p>
                            <p>
                              {detailsData?.policy_details?.formated_hard_quote}
                            </p>
                          </li>
                        ) : null}
                        {detailsData?.policy_details?.issued_date ? (
                          <li>
                            <p>Issued Date</p>
                            <p>{detailsData?.policy_details?.issued_date}</p>
                          </li>
                        ) : null}
                        {detailsData?.policy_details?.expiry_date ? (
                          <li>
                            <p>Expiry Date</p>
                            <p>{detailsData?.policy_details?.expiry_date}</p>
                          </li>
                        ) : null}
                      </ul>
                    </div>
                  </div>
                </Box>
              ) : null}
              {detailsData?.policy_details?.peak_season_amount ||
              detailsData?.policy_details?.peak_season_amount == 0 ||
              detailsData?.policy_details?.peak_season_amount == "0" ? (
                <Box sx={{mb: 2}}>
                  <div className={style.myAccountDetails}>
                    <div className={style.myAccount}>
                      <h2>Stock Limits </h2>
                    </div>
                    <div className={style.clientDetailsText}>
                      <ul>
                        <li>
                          <p>Peak Season Amount</p>
                          <p>
                            {detailsData?.policy_details?.peak_season_amount}
                          </p>
                        </li>
                        <li>
                          <p>Stock Limit Amount</p>
                          <p>{detailsData?.policy_details?.stock_limit}</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </Box>
              ) : null}
              {detailsData?.policy_details?.shipping &&
              Object.keys(detailsData?.policy_details.shipping).length > 0 ? (
                <Box sx={{mb: 2}}>
                  <div className={style.myAccountDetails}>
                    <div className={style.myAccount}>
                      <h2> Shipping Limits</h2>
                    </div>
                    <div className={style.clientDetailsText}>
                      <ul>
                        {Object.entries(
                          detailsData.policy_details.shipping
                        ).map(([key, value]) => (
                          <li key={key}>
                            <p>{shippingKeyNamesObj[key]}</p>
                            <p>{value !== null ? value : "N/A"}</p>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </Box>
              ) : null}
              {detailsData?.policy_details?.memorandum_entrustments &&
              Object.keys(detailsData?.policy_details.memorandum_entrustments)
                .length > 0 ? (
                <Box sx={{mb: 2}}>
                  <div className={style.myAccountDetails}>
                    <div className={style.myAccount}>
                      <h2>Memorandum & Entrustments </h2>
                    </div>
                    <div className={style.clientDetailsText}>
                      <ul>
                        <li>
                          <p>Entrustment Limit</p>
                          <p>
                            {
                              detailsData?.policy_details
                                .memorandum_entrustments?.entrustment_limit
                            }
                          </p>
                        </li>
                        {/* <li>
                          <p>Entrustment Exposure</p>
                          <p>
                            {
                              detailsData?.policy_details
                                .memorandum_entrustments?.entrustment_exposure
                            }
                          </p>
                        </li> */}
                        {detailsData?.policy_details.memorandum_entrustments
                          ?.entrustments_increase_clause?.length > 0 ? (
                          <li>
                            <Box sx={{width: "100%"}}>
                              <p className={style.polDetailsTableHed}>
                                Additional Entrustments
                              </p>
                              <Paper className={style.propTableMain}>
                                <TableContainer
                                  component={Paper}
                                  className="emi-details-table"
                                >
                                  <Table aria-label="simple table">
                                    <TableHead>
                                      <TableRow>
                                        <TableCell align="center">#</TableCell>
                                        <TableCell align="center">
                                          Type of Business
                                        </TableCell>
                                        <TableCell align="center">
                                          Name of Business
                                        </TableCell>
                                        <TableCell align="center">
                                          Limit
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      <TableRow
                                        sx={{
                                          "&:last-child td, &:last-child th": {
                                            border: 0,
                                          },
                                        }}
                                      >
                                        {detailsData?.policy_details.memorandum_entrustments?.entrustments_increase_clause.map(
                                          (ent, idx) => (
                                            <>
                                              <TableCell align="center">
                                                {idx + 1}
                                              </TableCell>
                                              <TableCell align="center">
                                                {ent?.business_type ?? "N/A"}
                                              </TableCell>
                                              <TableCell align="center">
                                                {ent?.business_name ?? "N/A"}
                                              </TableCell>
                                              <TableCell align="center">
                                                {ent?.business_limit ?? "N/A"}
                                              </TableCell>
                                            </>
                                          )
                                        )}
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              </Paper>
                            </Box>
                          </li>
                        ) : null}
                      </ul>
                    </div>
                  </div>
                </Box>
              ) : null}
              {detailsData?.policy_details?.travel?.length > 0 ? (
                <Box sx={{mb: 2}}>
                  <div className={style.myAccountDetails}>
                    <div className={style.myAccount}>
                      <h2>Travel </h2>
                    </div>
                    <div className={style.clientDetailsText}>
                      <ul>
                        <li>
                          <Box sx={{width: "100%"}}>
                            <Paper className={style.propTableMain}>
                              <TableContainer
                                component={Paper}
                                className="emi-details-table"
                              >
                                <Table aria-label="simple table">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell align="center">#</TableCell>
                                      <TableCell align="center">Name</TableCell>
                                      <TableCell align="center">
                                        Number of Days
                                      </TableCell>
                                      {/* <TableCell align="center">
                                        Average Amount Carry
                                      </TableCell>
                                      <TableCell align="center">
                                        Max Amount Carry
                                      </TableCell> */}
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    <TableRow
                                      sx={{
                                        "&:last-child td, &:last-child th": {
                                          border: 0,
                                        },
                                      }}
                                    >
                                      {detailsData?.policy_details.travel.map(
                                        (tr, idx) => (
                                          <>
                                            <TableCell align="center">
                                              {idx + 1}
                                            </TableCell>
                                            <TableCell align="center">
                                              {tr?.name ?? "N/A"}
                                            </TableCell>
                                            <TableCell align="center">
                                              {tr?.no_of_days ?? "N/A"}
                                            </TableCell>
                                          </>
                                        )
                                      )}
                                    </TableRow>
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Paper>
                          </Box>
                        </li>
                      </ul>
                    </div>
                  </div>
                </Box>
              ) : null}
              {detailsData?.policy_details?.exhibition?.length > 0 ? (
                <Box sx={{mb: 2}}>
                  <div className={style.myAccountDetails}>
                    <div className={style.myAccount}>
                      <h2>Exhibition</h2>
                    </div>
                    <div className={style.clientDetailsText}>
                      <ul>
                        <li>
                          <Box sx={{width: "100%"}}>
                            <Paper className={style.propTableMain}>
                              <TableContainer
                                component={Paper}
                                className="emi-details-table"
                              >
                                <Table aria-label="simple table">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell align="center">#</TableCell>
                                      <TableCell align="center">
                                        Transit Type
                                      </TableCell>
                                      <TableCell align="center">
                                        Limit
                                      </TableCell>
                                      <TableCell align="center">
                                        Aggregate
                                      </TableCell>
                                      {/* <TableCell align="center">
                                        Average Amount Carry
                                      </TableCell>
                                      <TableCell align="center">
                                        Max Amount Carry
                                      </TableCell> */}
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    <TableRow
                                      sx={{
                                        "&:last-child td, &:last-child th": {
                                          border: 0,
                                        },
                                      }}
                                    >
                                      {detailsData?.policy_details.exhibition.map(
                                        (exh, idx) => (
                                          <>
                                            <TableCell align="center">
                                              {idx + 1}
                                            </TableCell>
                                            <TableCell align="center">
                                              {exh?.transit_type
                                                ? toCapitalCase(
                                                    exh?.transit_type
                                                  )
                                                : "N/A"}
                                            </TableCell>
                                            <TableCell align="center">
                                              {exh?.exhibition_limit ?? "N/A"}
                                            </TableCell>
                                            <TableCell align="center">
                                              {exh?.exhibition_aggregate ??
                                                "N/A"}
                                            </TableCell>
                                          </>
                                        )
                                      )}
                                    </TableRow>
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Paper>
                          </Box>
                        </li>
                      </ul>
                    </div>
                  </div>
                </Box>
              ) : null}
            </Grid>
          </Grid>
        </Box>
      </Drawer>

      <Drawer anchor="right" open={openEdit} onClose={toggleEditDrawer(false)}>
        <Box
          sx={{width: {xl: 1024, lg: 800, md: 800, sm: 650, xs: 350}}}
          role="presentation"
          className={style.DetailsDrawerMain}
        >
          <Profile
            brokerIsEditor={true}
            clientOfBroker={{
              ...(detailsData?.user_details || {}),
              id: uid,
            }}
            fetchDetailsAfterUpdate={fetchDetailsAfterUpdate}
          />
        </Box>
      </Drawer>
    </>
  );
};

export default DetailsComponent;
